import { useState } from 'react'
import { useFocusWithin, useHover } from 'react-aria'

/**
 * Custom hook to pause toast timer on hover or focus
 * Returns pause state and interaction props to spread on the toast element
 */
export function usePauseOnInteraction(enabled: boolean) {
  const [isFocusWithinState, setIsFocusWithinState] = useState(false)

  const { hoverProps, isHovered } = useHover({ isDisabled: !enabled })
  const { focusWithinProps } = useFocusWithin({
    isDisabled: !enabled,
    onFocusWithinChange: setIsFocusWithinState,
  })

  const isPaused = enabled && (isHovered || isFocusWithinState)

  return {
    isPaused,
    interactionProps: { ...hoverProps, ...focusWithinProps },
  }
}

